import { render } from "./AcquisitorTable.vue?vue&type=template&id=41b31c9e"
import script from "./AcquisitorTable.vue?vue&type=script&lang=js"
export * from "./AcquisitorTable.vue?vue&type=script&lang=js"

import "./AcquisitorTable.vue?vue&type=style&index=0&id=41b31c9e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__